import { render, staticRenderFns } from "./JianKang_PainSpot_Survey.vue?vue&type=template&id=701802a8&scoped=true"
import script from "./JianKang_PainSpot_Survey.vue?vue&type=script&lang=js"
export * from "./JianKang_PainSpot_Survey.vue?vue&type=script&lang=js"
import style0 from "./JianKang_PainSpot_Survey.vue?vue&type=style&index=0&id=701802a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701802a8",
  null
  
)

export default component.exports